import Vue from 'vue';
import Tracking from './Tracking.vue';
import store from './store/store';
import i18n from './plugins/i18n';
import axios from 'axios';
import interceptorsSetup from './helpers/interceptors';
import Popover from 'vue-js-popover';
import {
  getAttr,
  addThemeStylesheet,
  parseIntSafe,
  parseBool,
  extractShipment,
  normalizeBrand,
} from './helpers/init-helper';
import { WebsiteByShopId } from './enums/shop-enum';
import { isEDDEnabledSite } from './utils/websiteUtils';

Vue.use(Popover);

interceptorsSetup();

const $ = self => document.querySelector(self);

const element = $('#tracking');
if (!element) {
  console.error('Élément #tracking introuvable — arrêt du bootstrap Vue.');
} else {
  const rawTheme = getAttr(element, 'theme', { fallback: 'MR' });
  const theme = rawTheme === '' ? 'MR' : rawTheme;
  const themeUpper = theme ? theme.toUpperCase() : 'MR';
  store.commit('setTheme', themeUpper);
  addThemeStylesheet(themeUpper);

  const langueAttr = getAttr(element, 'langue', { fallback: null });
  if (langueAttr) {
    store.commit('setLangue', langueAttr);
  }

  const shopId = parseIntSafe(getAttr(element, 'shopId'), null);
  const site = shopId != null ? WebsiteByShopId[shopId] : null;
  if (isEDDEnabledSite(site)) {
    store.commit('setShowEstimatedDeliveryDate', true);
  }

  const showFilterLocker = parseBool(getAttr(element, 'showFilterLocker'), false);
  store.commit('setShowFilterLocker', showFilterLocker);

  const cmrBigEventActive = parseBool(getAttr(element, 'cmrBigEventActive'), false);
  store.commit('setCmrBigEventActive', cmrBigEventActive);

  const replaceLockersEnAvant = parseBool(getAttr(element, 'replaceLockersEnAvant'), false);
  store.commit('setReplaceLockersEnAvant', replaceLockersEnAvant);

  const minLengthNumExpe = parseIntSafe(getAttr(element, 'minLengthNumExpe'), null);
  if (minLengthNumExpe != null) {
    store.commit('setMinLengthNumExpe', minLengthNumExpe);
  }
  const maxLengthNumExpe = parseIntSafe(getAttr(element, 'maxLengthNumExpe'), null);
  if (maxLengthNumExpe != null) {
    store.commit('setMaxLengthNumExpe', maxLengthNumExpe);
  }

  const token = getAttr(element, 'token', { fallback: null });
  if (token) {
    axios.defaults.headers.common['RequestVerificationToken'] = token;
  }

  if (window.location.pathname.includes('nl-be')) {
    store.commit('setLangue', 'nlbe');
  }

  const usp = new URLSearchParams(window.location.search);
  let shipment = '';
  let postcode = '';
  let brand = '';
  let anyParam = false;

  const shipmentKeys = [
    'exp',
    'nexp',
    'numeroExpedition',
    'numeroexpedition',
    'e',
    'NumeroExpedition',
  ];
  for (const k of shipmentKeys) {
    const v = usp.get(k);
    if (v) {
      shipment = extractShipment(v);
      anyParam = true;
      break;
    }
  }

  const cp = usp.get('codepostal') || usp.get('codePostal') || usp.get('CodePostal');
  if (cp) {
    postcode = cp;
    anyParam = true;
  }

  const brandDirect = usp.get('codeMarque') || usp.get('codemarque') || usp.get('m');
  const brandShort = usp.get('ens') || usp.get('cmrq');

  if (brandDirect) {
    brand = normalizeBrand(brandDirect, false);
    anyParam = true;
  } else if (brandShort) {
    brand = normalizeBrand(brandShort, true);
    anyParam = true;
  }

  if (anyParam) {
    store.commit('setDoesParameterSet', true);
  }

  new Vue({
    store,
    i18n,
    render: h =>
      h(Tracking, {
        props: {
          shipment,
          postcode,
          brand,
        },
      }),
  }).$mount('#tracking');
}
